require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-how-can-the-world-bank-align-its-portfolio-with-the.json") })
        }
      }, "path---en-us-update-how-can-the-world-bank-align-its-portfolio-with-the");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-how-can-the-world-bank-align-its-portfolio-with-the!./.cache/json/en-us-update-how-can-the-world-bank-align-its-portfolio-with-the.json
// module id = 704
// module chunks = 231608221292675